module.exports = __webpack_public_path__ + "img/top-fitness.a6cd32f.jpg";